<template>
  <a-drawer width="45%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item :label="$t('名称')" prop="name">
        <a-input v-model="form.name" :maxLength="64" :placeholder="$t('请输入')+$t('名称')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('封面/logo')" prop="coverPic">
        <oss-upload-single :height="100" :width="100" v-model="form.coverPic" prefix="recycle" type="img"/>
      </a-form-model-item>
      <a-form-model-item :label="$t('门店图片')" prop="images">
        <oss-upload-multi :max-count="9" v-model="form.images" prefix="recycle" type="img"/>
      </a-form-model-item>
      <a-form-model-item :label="$t('回收品类')" prop="recycleCategory">
        <a-input v-model="form.recycleCategory" :maxLength="200" :placeholder="$t('请输入')+$t('回收品类')+'，'+$t('多个用逗号分隔')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('联系人')" prop="contactName">
        <a-input v-model="form.contactName" :maxLength="32" :placeholder="$t('请输入')+$t('联系人')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('联系电话')" prop="contactPhone">
        <a-input v-model="form.contactPhone" :maxLength="20" :placeholder="$t('请输入')+$t('联系电话')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('营业时间')" prop="businessHours">
        <a-input v-model="form.businessHours" :maxLength="100" :placeholder="$t('请输入')+$t('营业时间')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('省')" prop="province">
        <a-input v-model="form.province" :maxLength="32" :placeholder="$t('请输入')+$t('省')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('市')" prop="city">
        <a-input v-model="form.city" :maxLength="32" :placeholder="$t('请输入')+$t('市')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('区/县')" prop="district">
        <a-input v-model="form.district" :maxLength="32" :placeholder="$t('请输入')+$t('区/县')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('详细地址')" prop="address">
        <a-input v-model="form.address" :maxLength="128" :placeholder="$t('请输入')+$t('详细地址')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('经度')" prop="longitude">
        <a-input-number v-model="form.longitude" style="width: 100%" :placeholder="$t('请输入')+$t('经度')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('纬度')" prop="latitude">
        <a-input-number v-model="form.latitude" style="width: 100%" :placeholder="$t('请输入')+$t('纬度')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('简介')" prop="intro">
        <a-input v-model="form.intro" :maxLength="500" :placeholder="$t('请输入')+$t('简介')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item :label="$t('状态')" prop="status">
        <a-radio-group v-model="form.status">
          <a-radio :value="20">{{ $t('上架') }}</a-radio>
          <a-radio :value="10">{{ $t('下架') }}</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item :label="$t('首页展示')" prop="isHomeVisible">
        <a-switch v-model="form.isHomeVisible" />
      </a-form-model-item>
      <a-form-model-item :label="$t('排序')" prop="sort">
        <a-input-number v-model="form.sort" :min="0" :max="21474836" style="width: 100%" :placeholder="$t('请输入')+$t('排序')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('备注')" prop="remark">
        <a-input v-model="form.remark" :maxLength="200" :placeholder="$t('请输入')+$t('备注')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getRecycleStore, addRecycleStore, updateRecycleStore } from '@/api/recycle/store'
import { mapGetters } from 'vuex'
import OssUploadSingle from "@/components/OssUploadSingle/index.vue"
import OssUploadMulti from "@/components/OssUploadMulti/index.vue"

export default {
  name: 'CreateForm',
  components: {
    OssUploadSingle,
    OssUploadMulti
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      form: this.initForm(),
      formType: 1,
      open: false,
      rules: {
        name: [{ required: true, message: '名称不能为空', trigger: 'blur' }]
      }
    }
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  methods: {
    initForm() {
      return {
        id: null,
        name: null,
        coverPic: null,
        images: null,
        recycleCategory: null,
        contactName: null,
        contactPhone: null,
        businessHours: null,
        province: null,
        city: null,
        district: null,
        address: null,
        longitude: null,
        latitude: null,
        intro: null,
        status: 20,
        isHomeVisible: false,
        sort: 0,
        remark: null
      }
    },
    onClose() {
      this.open = false
      this.reset()
    },
    cancel() {
      this.open = false
      this.reset()
    },
    reset() {
      this.formType = 1
      this.form = this.initForm()
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getRecycleStore({ "id": id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateRecycleStore(this.form).then(response => {
              this.$message.success(this.$t('修改成功'), 3)
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addRecycleStore(this.form).then(response => {
              this.$message.success(this.$t('新增成功'), 3)
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
